import { render } from "./item_quantity.vue?vue&type=template&id=6b015b2d"
import script from "./item_quantity.vue?vue&type=script&lang=js"
export * from "./item_quantity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__